<template>
  <div class="maps">
    <span class="title">地图导航</span>
    <div class="content">
      <router-link :to="{ path: '/towns', query: towns[1] }" style="
                          position: absolute;
                          top: 177px;
                          left: 321px;
                          width: 30px;
                          height: auto;
                          line-height:15px;
                        " target="_blank">露峰街道</router-link>
      <router-link :to="{ path: '/towns', query: towns[2] }" style="
                          position: absolute;
                          top: 182px;
                          left: 285px;
                          width: 30px;
                          height: auto;
                          line-height:15px;
                        " target="_blank">琴台街道</router-link>
      <router-link :to="{ path: '/towns', query: towns[3] }" style="
                          position: absolute;
                          top: 214px;
                          left: 292px;
                          width: 30px;
                          height: auto;
                          line-height:15px;
                        " target="_blank">鲁阳街道</router-link>
      <router-link :to="{ path: '/towns', query: towns[4] }" style="
                          position: absolute;
                          top: 210px;
                          left: 326px;
                          width: 30px;
                          height: auto;
                          line-height:15px;
                        " target="_blank">汇源街道</router-link><router-link :to="{ path: '/towns', query: towns[5] }" style="
                          position: absolute;
                          top: 190px;
                          left: 194px;
                          width: 15px;
                          height: auto;
                        " target="_blank">下汤镇</router-link><router-link :to="{ path: '/towns', query: towns[6] }" style="
                          position: absolute;
                          top: 154px;
                          left: 311px;
                          width: auto;
                          height: auto;
                        " target="_blank">梁洼镇</router-link><router-link :to="{ path: '/towns', query: towns[7] }" style="
                          position: absolute;
                          top: 239px;
                          left: 447px;
                          width: 15px;
                          height: auto;
                        " target="_blank">张官营镇</router-link><router-link :to="{ path: '/towns', query: towns[8] }" style="
                          position: absolute;
                          top: 237px;
                          left: 381px;
                          width: 15px;
                          height: auto;
                        " target="_blank">张良镇</router-link><router-link :to="{ path: '/towns', query: towns[9] }" style="
                          position: absolute;
                          top: 199px;
                          left: 28px;
                          width: auto;
                          height: auto;
                        " target="_blank">尧山镇</router-link><router-link :to="{ path: '/towns', query: towns[10] }" style="
                          position: absolute;
                          top: 117px;
                          left: 196px;
                          width: 15px;
                          height: auto;
                        " target="_blank">瓦屋镇</router-link><router-link :to="{ path: '/towns', query: towns[11] }" style="
                          position: absolute;
                          top: 176px;
                          left: 130px;
                          width: 15px;
                          height: auto;
                        " target="_blank">赵村镇</router-link><router-link :to="{ path: '/towns', query: towns[12] }" style="
                          position: absolute;
                          top: 242px;
                          left: 136px;
                          width: 30px;
                          height: auto;
                        " target="_blank">四棵树乡</router-link>
      <router-link :to="{ path: '/towns', query: towns[13] }" style="
                          position: absolute;
                          top: 256px;
                          left: 185px;
                          width: auto;
                          height: auto;
                        " target="_blank">团城乡</router-link><router-link :to="{ path: '/towns', query: towns[14] }" style="
                          position: absolute;
                          top: 260px;
                          left: 245px;
                          width: auto;
                          height: auto;
                        " target="_blank">熊背乡</router-link><router-link :to="{ path: '/towns', query: towns[15] }" style="
                          position: absolute;
                          top: 253px;
                          left: 303px;
                          width: 15px;
                          height: auto;
                        " target="_blank">让河乡</router-link><router-link :to="{ path: '/towns', query: towns[16] }" style="
                          position: absolute;
                          top: 105px;
                          left: 228px;
                          width: 15px;
                          height: auto;
                        " target="_blank">观音寺乡</router-link><router-link :to="{ path: '/towns', query: towns[17] }"
        style="
                          position: absolute;
                          top: 202px;
                          left: 222px;
                          width: 45px;
                          height: auto;
                        " target="_blank">昭平台库区乡</router-link><router-link :to="{ path: '/towns', query: towns[18] }"
        style="
                          position: absolute;
                          top: 115px;
                          left: 153px;
                          width: 15px;
                          height: auto;
                        " target="_blank">背孜乡</router-link><router-link :to="{ path: '/towns', query: towns[19] }" style="
                          position: absolute;
                          top: 120px;
                          left: 262px;
                          width: 15px;
                          height: auto;
                        " target="_blank">仓头乡</router-link><router-link :to="{ path: '/towns', query: towns[20] }" style="
                          position: absolute;
                          top: 175px;
                          left: 238px;
                          width: auto;
                          height: auto;
                        " target="_blank">董周乡</router-link><router-link :to="{ path: '/towns', query: towns[21] }" style="
                          position: absolute;
                          top: 130px;
                          left: 291px;
                          width: 15px;
                          height: auto;
                        " target="_blank">张店乡</router-link><router-link :to="{ path: '/towns', query: towns[22] }" style="
                          position: absolute;
                          top: 184px;
                          left: 366px;
                          width: auto;
                          height: auto;
                        " target="_blank">辛集乡</router-link><router-link :to="{ path: '/towns', query: towns[23] }" style="
                          position: absolute;
                          top: 224px;
                          left: 415px;
                          width: 15px;
                          height: auto;
                        " target="_blank">磙子营乡</router-link><router-link :to="{ path: '/towns', query: towns[24] }"
        style="
                          position: absolute;
                          top: 250px;
                          left: 335px;
                          width: 15px;
                          height: auto;
                        " target="_blank">马楼乡</router-link>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      towns: [],
    };
  },
  created() {

  },
  beforeCreate() {

  },

  mounted() {
    // 地图导航数据
    let url = "ditudaohang";
    // console.log("地图导航");
    // console.log(this.ajax_url(url));
    this.towns = this.ajax_url(url).data;
  },
  computed: {},
  watch: {},
  methods: {},
};
</script>

<style scoped>
.maps {
  /* padding: 0 37px; */
  /* width: 484px; */
  width: 558px;
  height: 497px;
  background: #ffffff;
  box-shadow: 0px 0px 24px 0px rgba(21, 21, 21, 0.1);
}

.title {
  display: block;
  padding: 0 37px;
  width: 100%;
  height: 80px;
  border-bottom: 1px solid #dbdbdb;

  font-size: 37px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #49C873;
  line-height: 80px;
}

.content {
  margin: 0 auto;
  display: block;
  width: 1000px;
  height: 391px;
  position: relative;
  background: url("../../../assets/img/map.png") no-repeat center;
  background-size: 880px 90%;
}

.content a {
  display: block;
  font-size: 15px;
  color: #3b3b3b;
  line-height: 15px;
}

.content a:hover {
  display: block;
  transition: 1.5s;
  transform: scale(1.2, 1.2);
  color: black;
}
</style>
